import store from "../store"
import { ALERT } from "../store/data/actionTypes"

export const systemAlert = (contents, options = {}) => {

  const alertData = {
    contents,
    ...options
  }
  store.dispatch({
    type: ALERT,
    payload: contents ? alertData : null
  })
}

export default systemAlert